import { render, staticRenderFns } from "./IntegrationSummary.vue?vue&type=template&id=a5404652&scoped=true&"
import script from "./IntegrationSummary.vue?vue&type=script&lang=ts&"
export * from "./IntegrationSummary.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationSummary.vue?vue&type=style&index=0&id=a5404652&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5404652",
  null
  
)

export default component.exports